export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "nl-NL": {
        "gerechtvaardigdBelangVerklaring": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autobedrijven zullen je nu enkel nog maar benaderen wanneer dat noodzakelijk is voor de uitvoering van hun dienstverlening."])}
      },
      "fr-FR": {
        "gerechtvaardigdBelangVerklaring": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les garages ne vous contacteront desormais que lorsque cela est necessaire a l'execution de leurs services."])}
      },
      "de-DE": {
        "gerechtvaardigdBelangVerklaring": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autohaeuser werden Sie nur noch kontaktieren, wenn dies fuer die Erbringung ihrer Dienstleistungen erforderlich ist."])}
      },
      "da-DK": {
        "gerechtvaardigdBelangVerklaring": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autohuse vil kun kontakte dig, naar det er noedvendigt for at levere deres tjenester."])}
      },
      "en-UK": {
        "gerechtvaardigdBelangVerklaring": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dealerships will only contact you when this is necessary to provide their services."])}
      }
    }
  })
}